export const white = 0xffffff;
export const specular = 0x111111;
export const blueLight = 0x00c4cc;
export const dim = 3;
export const gumShininess = 20;
export const teethInfRightStart = 11;
export const teethInfRightStop = 18;
export const teethInfLeftStart = 21;
export const teethInfLeftStop = 28;
export const teethSupLeftStart = 31;
export const teethSupLeftStop = 38;
export const teethSupRightStart = 41;
export const teethSupRightStop = 48;
export const httpOKcode = 200;
export const httpFinalState = 4;
export const classificationRowNb = 5;
export const enMonths = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
export const frMonths = ['Jan.', 'Fév.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sep.', 'Oct.', 'Nov.', 'Déc.'];
export const toastTimeoutMS = 3000;
export const toastPosition = 'toast-top-center';
